var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgLocation = props => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M19 9A7 7 0 0 0 5 9a6.89 6.89 0 0 0 .69 3l.08.14.27.48 4.88 8.72a1.25 1.25 0 0 0 2.18 0l4.9-8.69a4.76 4.76 0 0 0 .28-.49l.08-.14A6.89 6.89 0 0 0 19 9Zm-7 3a3 3 0 1 1 3-3 3 3 0 0 1-3 3Z"
})));
export default SvgLocation;